var buffer = require('./lib/buffer-source')
var media = require('./lib/media-source')

module.exports = webAudioPlayer
function webAudioPlayer (src, opt) {
  if (!src) throw new TypeError('must specify a src parameter')
  opt = opt || {}
  if (opt.buffer) return buffer(src, opt)
  else return media(src, opt)
}



//////////////////
// WEBPACK FOOTER
// ./~/web-audio-player/index.js
// module id = 989
// module chunks = 1 2 3 4 5